"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PERIOD_METRICS_BY_SECTION = exports.DEFAULT_SNAPSHOT_METRICS_BY_SECTION = exports.DEFAULT_CUSTOMERS_REVENUE_PERIOD_METRICS = exports.DEFAULT_CUSTOMERS_ACTIVITY_PERIOD_METRICS = exports.DEFAULT_CUSTOMERS_PERIOD_REPORT_METRICS = exports.DEFAULT_SHIPPING_PERIOD_METRICS = exports.DEFAULT_TAX_PERIOD_METRICS = exports.DEFAULT_SALES_PERIOD_METRICS = exports.DEFAULT_PAYMENTS_PERIOD_METRICS = exports.DEFAULT_PAYMENTS_SNAPSHOT_METRICS = exports.DEFAULT_CUSTOMERS_REVENUE_SNAPSHOT_METRICS = exports.DEFAULT_CUSTOMERS_ACTIVITY_SNAPSHOT_METRICS = exports.DEFAULT_SUPPLIERS_SNAPSHOT_METRICS = exports.DEFAULT_INVENTORY_SNAPSHOT_METRICS = exports.DEFAULT_PRODUCTS_SNAPSHOT_METRICS = exports.DEFAULT_CUSTOMERS_SNAPSHOT_METRICS = exports.DEFAULT_ORDERS_SNAPSHOT_METRICS = void 0;
const report_common_types_1 = require("./report-common-types");
const report_snapshot_types_1 = require("./report-snapshot-types");
const report_period_types_1 = require("./report-period-types");
const common_1 = require("../common");
// --- Snapshot defaults (used when no report exists) ---
const DEFAULT_LONG = common_1.Long.fromNumber(0);
const DEFAULT_ORDER_GROUP_METRICS = {
    count: 0,
    totalValueScaled: DEFAULT_LONG,
    averageValueScaled: DEFAULT_LONG,
    averageProductsPerOrder: 0,
    lineItemsCount: 0,
};
exports.DEFAULT_ORDERS_SNAPSHOT_METRICS = {
    byStatus: {
        total: DEFAULT_ORDER_GROUP_METRICS,
        fulfilled: DEFAULT_ORDER_GROUP_METRICS,
        returned: DEFAULT_ORDER_GROUP_METRICS,
        cancelled: DEFAULT_ORDER_GROUP_METRICS,
        inProcess: DEFAULT_ORDER_GROUP_METRICS,
        backOrder: DEFAULT_ORDER_GROUP_METRICS,
        preorder: DEFAULT_ORDER_GROUP_METRICS,
        refunded: DEFAULT_ORDER_GROUP_METRICS,
        delivered: DEFAULT_ORDER_GROUP_METRICS,
        rejectedPayment: DEFAULT_ORDER_GROUP_METRICS,
        awaitingStock: DEFAULT_ORDER_GROUP_METRICS,
        unpaid: DEFAULT_ORDER_GROUP_METRICS,
        paid: DEFAULT_ORDER_GROUP_METRICS,
    },
    topDayWithMostOrders: Object.assign(Object.assign({}, DEFAULT_ORDER_GROUP_METRICS), { date: "" }),
};
exports.DEFAULT_CUSTOMERS_SNAPSHOT_METRICS = {
    totalCustomers: 0,
    totalCustomerCompanies: 0,
    totalCustomerCompaniesUsersCount: 0,
    totalRetailCustomers: 0,
    totalWholesaleCustomers: 0,
    totalBothTypesCustomers: 0,
};
exports.DEFAULT_PRODUCTS_SNAPSHOT_METRICS = {
    activeProductsVariantsCount: 0,
    inactiveProductsVariantsCount: 0,
    totalProductsVariantsCount: 0,
    totalProductsCount: 0,
    activeProductsCount: 0,
    inactiveProductsCount: 0,
    activeBundlesCount: 0,
    inactiveBundlesCount: 0,
    totalBundlesCount: 0,
    activeBundleVariantsCount: 0,
    inactiveBundleVariantsCount: 0,
    totalBundleVariantsCount: 0,
    topProductsWithLowStock: [],
    topProductsWithHighStock: [],
    topBestSellers: [],
};
const DEFAULT_INVENTORY_VARIANTS_GROUP = {
    totalVariants: 0,
    totalVariantsItems: 0,
    totalVariantsValueScaled: DEFAULT_LONG,
};
exports.DEFAULT_INVENTORY_SNAPSHOT_METRICS = {
    byStatusInOrders: {
        inStock: DEFAULT_INVENTORY_VARIANTS_GROUP,
        allocated: DEFAULT_INVENTORY_VARIANTS_GROUP,
        onPurchaseOrder: DEFAULT_INVENTORY_VARIANTS_GROUP,
        onBackOrder: DEFAULT_INVENTORY_VARIANTS_GROUP,
        onPreorder: DEFAULT_INVENTORY_VARIANTS_GROUP,
        returned: DEFAULT_INVENTORY_VARIANTS_GROUP,
        notTracked: DEFAULT_INVENTORY_VARIANTS_GROUP,
    },
};
/** Placeholder for required supplier refs when there are no suppliers. Cast to your env's ObjectId when needed. */
const NO_SUPPLIER_ID = undefined;
exports.DEFAULT_SUPPLIERS_SNAPSHOT_METRICS = {
    numberOfSuppliers: 0,
    averageProductsPerSupplier: 0,
    suppliersWithMostProductsSupplied: [],
    suppliersWithLeastProducts: [],
    supplierWithMostProducts: { supplierId: NO_SUPPLIER_ID, productCount: 0 },
    suppliersWithMostPurchaseOrders: [],
};
exports.DEFAULT_CUSTOMERS_ACTIVITY_SNAPSHOT_METRICS = {
    uniqueCustomersWithOrders: 0,
    ordersWithCustomer: 0,
    guestOrders: 0,
    repeatCustomers: 0,
    repeatRateBps: 0,
    ordersPerCustomer: 0,
};
exports.DEFAULT_CUSTOMERS_REVENUE_SNAPSHOT_METRICS = {};
exports.DEFAULT_PAYMENTS_SNAPSHOT_METRICS = {
    totalIncompletePaymentsCount: 0,
    totalFailedPaymentsCount: 0,
    totalRefundCount: 0,
    totalGrossPaymentVolumeScaled: DEFAULT_LONG,
    totalRefundedAmountScaled: DEFAULT_LONG,
    totalNetPaymentVolumeScaled: DEFAULT_LONG,
    totalIncompletePaymentVolumeScaled: DEFAULT_LONG,
    totalFailedPaymentVolumeScaled: DEFAULT_LONG,
    totalSuccessfulPaymentsCount: 0,
};
// --- Period defaults (used when no report exists) ---
const EMPTY_GRANULARITY = report_common_types_1.TimeSeriesGranularity.DAY;
exports.DEFAULT_PAYMENTS_PERIOD_METRICS = {
    summary: {
        grossPaymentVolumeScaled: DEFAULT_LONG,
        refundedAmountScaled: DEFAULT_LONG,
        netPaymentVolumeScaled: DEFAULT_LONG,
        incompletePaymentVolumeScaled: DEFAULT_LONG,
        failedPaymentVolumeScaled: DEFAULT_LONG,
        incompletePaymentsCount: 0,
        successfulPaymentsCount: 0,
        failedPaymentsCount: 0,
        refundCount: 0,
        paymentSuccessRateBps: 0,
    },
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_SALES_PERIOD_METRICS = {
    summary: {
        saleCount: 0,
        discountedPercentageBps: 0,
        averageItemsPerSale: 0,
        lineItemsCount: 0,
    },
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_TAX_PERIOD_METRICS = {
    summary: {
        taxAmountScaled: DEFAULT_LONG,
        taxableAmountScaled: DEFAULT_LONG,
        totalAmountScaled: DEFAULT_LONG,
        unpaidTaxAmountScaled: DEFAULT_LONG,
        paidTaxAmountScaled: DEFAULT_LONG,
        refundedTaxAmountScaled: DEFAULT_LONG,
        netTaxAmountScaled: DEFAULT_LONG,
        byTaxClass: [],
    },
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_SHIPPING_PERIOD_METRICS = {};
exports.DEFAULT_CUSTOMERS_PERIOD_REPORT_METRICS = {
    summary: {
        customerCount: 0,
        customerCompaniesCount: 0,
    },
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_CUSTOMERS_ACTIVITY_PERIOD_METRICS = {
    summary: {
        uniqueCustomersWithOrders: 0,
        ordersWithCustomer: 0,
        guestOrders: 0,
        repeatCustomers: 0,
        repeatRateBps: 0,
        ordersPerCustomer: 0,
    },
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_CUSTOMERS_REVENUE_PERIOD_METRICS = {
    summary: {},
    series: [],
    granularity: EMPTY_GRANULARITY,
    fromDate: "",
    toDate: "",
};
exports.DEFAULT_SNAPSHOT_METRICS_BY_SECTION = {
    [report_snapshot_types_1.ReportSnapshotSection.ORDERS]: exports.DEFAULT_ORDERS_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.CUSTOMERS]: exports.DEFAULT_CUSTOMERS_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.PRODUCTS]: exports.DEFAULT_PRODUCTS_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.INVENTORY]: exports.DEFAULT_INVENTORY_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.SUPPLIERS]: exports.DEFAULT_SUPPLIERS_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.PAYMENTS]: exports.DEFAULT_PAYMENTS_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.CUSTOMERS_ACTIVITY]: exports.DEFAULT_CUSTOMERS_ACTIVITY_SNAPSHOT_METRICS,
    [report_snapshot_types_1.ReportSnapshotSection.CUSTOMERS_REVENUE]: exports.DEFAULT_CUSTOMERS_REVENUE_SNAPSHOT_METRICS,
};
exports.DEFAULT_PERIOD_METRICS_BY_SECTION = {
    [report_period_types_1.ReportPeriodSection.PAYMENTS]: exports.DEFAULT_PAYMENTS_PERIOD_METRICS,
    [report_period_types_1.ReportPeriodSection.SALES]: exports.DEFAULT_SALES_PERIOD_METRICS,
    [report_period_types_1.ReportPeriodSection.CUSTOMERS]: exports.DEFAULT_CUSTOMERS_PERIOD_REPORT_METRICS,
    [report_period_types_1.ReportPeriodSection.CUSTOMERS_ACTIVITY]: exports.DEFAULT_CUSTOMERS_ACTIVITY_PERIOD_METRICS,
    [report_period_types_1.ReportPeriodSection.CUSTOMERS_REVENUE]: exports.DEFAULT_CUSTOMERS_REVENUE_PERIOD_METRICS,
    [report_period_types_1.ReportPeriodSection.TAX]: exports.DEFAULT_TAX_PERIOD_METRICS,
    [report_period_types_1.ReportPeriodSection.SHIPPING]: exports.DEFAULT_SHIPPING_PERIOD_METRICS,
};
